import React from 'react';
import { Drawer as MuiDrawer, DrawerProps as MuiDrawerProps } from '@mui/material';


interface CustomDrawerProps extends MuiDrawerProps {
    children: React.ReactNode;
    isOpen: boolean;
    onClose: () => void;
}

const CustomDrawer: React.FC<CustomDrawerProps> = ({ children, isOpen, onClose, ...otherProps }) => {
    return (
        <MuiDrawer
            anchor="bottom"
            open={isOpen}
            onClose={onClose}
            PaperProps={{style: {borderTopLeftRadius: '24px', borderTopRightRadius: '24px'}}}
            {...otherProps}
        >
            {children}
        </MuiDrawer>
    );
};

export default CustomDrawer;